import socket from "./socket";
import { message } from "./message";
import { mail } from "./mail";
import { friend } from "./friend";
import { refreshReq } from "./refresh";
import { store } from "../store/store";

let listenersCreated = false;

/**
 * Authorize the user over the socket connection as well
 */
export const authorize = () => {
  // Step 1: Check if user has already been authorized
  const isAuthorized = store.getters["getSocketAuthorized"];
  let authToken = store.getters.userInfo;

  if (!isAuthorized && authToken.userId !== 0 && authToken.token !== "") {
    // Step 2: If not authorized get the auth token
    authToken = {
      userId: authToken.userId,
      token: authToken.token
    };

    // Step 3: Send auth request
    socket.emit("authorize", authToken);
  }

  // Set that the user has been authorized
  socket.on("authorized", () => {
    // Successfully authorized
    store.commit("setSocketAuthorized", true);

    if (!listenersCreated) {
      // Listen to message requests
      message(socket);

      // Listen to friend
      friend(socket);

      // Listen to new mails
      mail(socket);

      // Listen to refresh requests
      refreshReq(socket);

      // Listeners created
      listenersCreated = true;
    }
  });
};
